import React from "react";
import AddCarSection from "components/dashboard/cars/AddCarSection";
import { requireAuth } from "util/auth.js";
import { useRouter } from "next/router";
import Head from "next/head";

function AddCarPage(props) {
  const router = useRouter();

  const handleSuccessfulCarUpload = (carId) =>
    router.push(`/dashboard/car/${carId}/edit-photos`);

  return (
    <>
      <Head>
        <title>Pridėk savo automobilį | Automobilių Nuoma | TryMyCar</title>
      </Head>
      <AddCarSection
        bg="white"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        title="Pridėkite automobilį"
        subtitle=""
        buttonText="Pridėti automobilį"
        buttonColor="primary"
        showNameField={true}
        onSuccessfulCarUpload={handleSuccessfulCarUpload}
      />
    </>
  );
}

export default requireAuth(AddCarPage);
